import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Webhooks from './pages/Webhooks';
import SecurityPolicies from './pages/SecurityPolicies';
import OperationalLog from './pages/OperationalLog';
import { isAuthenticated } from './utils/auth';
import './App.css';

// Protected Route component
function ProtectedRoute({ children }) {
    return isAuthenticated() ? children : <Navigate to="/login" />;
}

// Public Route component (redirect to dashboard if authenticated)
function PublicRoute({ children }) {
    return !isAuthenticated() ? children : <Navigate to="/" />;
}

function App() {
    return (
        <Router>
            <Routes>
                <Route
                    path="/login"
                    element={
                        <PublicRoute>
                            <Login />
                        </PublicRoute>
                    }
                />
                <Route
                    path="/"
                    element={
                        <ProtectedRoute>
                            <Dashboard />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/webhooks"
                    element={
                        <ProtectedRoute>
                            <Webhooks />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/security-policies"
                    element={
                        <ProtectedRoute>
                            <SecurityPolicies />
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/operational-log"
                    element={
                        <ProtectedRoute>
                            <OperationalLog />
                        </ProtectedRoute>
                    }
                />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Router>
    );
}

export default App;
